import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostCreateMessanger = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_MESSANGER
            });
            window.location.replace('/settings/messanger')
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostCreateMessanger as SetPostCreateMessanger
}